export function Bm_grid_settings(state = {MenuVisible: true, contentColWidth: 13}, action) {
    switch (action.type) {
        case 'FS_GRID_TOOGLE':
            return action.Bm_grid_settings;
        default:
            return state;
    	}
}